import { useQuery } from '@tanstack/react-query';
import { getImmigrationDocDrafts } from '../services/document-api/Documents';
import { IMMIGRATION_DOC_DRAFT_KEY } from 'src/utils/constants/queryKeys';

export const useGetImmigrationDocDrafts = (beneId: number) => {
  return useQuery({
    queryKey: [IMMIGRATION_DOC_DRAFT_KEY, beneId],
    queryFn: () => getImmigrationDocDrafts(beneId),
    enabled: !!beneId,
  });
};
